import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import Dashboard from './pages/dashboard';
import QuestionPractice from './pages/question-practice';
import ResultsAnalytics from './pages/results-analytics';
import BABOKTeaching from './pages/babok-teaching';
import Login from './pages/login';
import Registration from './pages/registration';
import StudyMaterials from './pages/study-materials';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<Dashboard />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/question-practice" element={<QuestionPractice />} />
        <Route path="/results-analytics" element={<ResultsAnalytics />} />
        <Route path="/babok-teaching" element={<BABOKTeaching />} />
        <Route path="/login" element={<Login />} />
        <Route path="/registration" element={<Registration />} />
        <Route path="/study-materials" element={<StudyMaterials />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
